"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var BASE_URL = "https://static.neshan.org";
var DEFAULT_URL_SCRIPT = "".concat(BASE_URL, "/sdk/leaflet/1.4.0/leaflet.js");
var DEFAULT_URL_STYLE = "".concat(BASE_URL, "/sdk/leaflet/1.4.0/leaflet.css");

var _default = function _default(props) {
  var createScriptStyle = function createScriptStyle() {
    var onError = props.onError,
        onLoad = props.onLoad; //-----import style

    if (!document.head.querySelector("link[href=\"".concat(DEFAULT_URL_STYLE, "\"]"))) {
      var style = document.createElement("link");
      style.href = DEFAULT_URL_STYLE;
      style.rel = "stylesheet";
      document.head.appendChild(style);
    } //------import script


    if (window.L) {
      if (onLoad) onLoad();
      return;
    }

    var script = document.body.querySelector("script[src=\"".concat(DEFAULT_URL_SCRIPT, "\"]")) || document.createElement("script");
    script.addEventListener("load", function () {
      if (onLoad) onLoad();
      return;
    });
    script.addEventListener("error", function () {
      if (onError) onError();
      return;
    });

    if (!script.src) {
      script.src = DEFAULT_URL_SCRIPT;
      document.body.appendChild(script);
    }
  };

  return createScriptStyle();
};

exports["default"] = _default;